import messages from "../messages";

export const CHAT_SUGGESTIONS = [
  {
    id: "suggest-topic",
    icon: "book-open",
    text: messages.suggestTopic,
    action: messages.suggestTopicAction
  },
  {
    id: "show-progress",
    icon: "time",
    text: messages.showProgress,
    action: messages.showProgressAction
  },
  {
    id: "upcoming-deadlines",
    icon: "calendar",
    text: messages.upcomingDeadlines,
    action: messages.upcomingDeadlinesAction
  },
  {
    id: "report-problem",
    icon: "alert-circle",
    text: messages.reportProblem,
    action: messages.reportProblemAction
  }
]; 